module.exports = __webpack_public_path__ + "static/media/bfile-offroad.d8fee522.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/bfile-offroad.svg
// module id = 168
// module chunks = 0